"use client";
"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Divider = void 0;
const react_1 = __importDefault(require("react"));
const foundations_1 = require("../../foundations");
const Divider = ({ sx }) => {
    return (react_1.default.createElement(foundations_1.Box, { as: "hr", sx: Object.assign(Object.assign({}, sx), { borderColor: "stroke02", borderStyle: "solid", borderWidth: "1px 0 0 0" }) }));
};
exports.Divider = Divider;
//# sourceMappingURL=Divider.js.map